<template>
  <section>
    <template v-for="(day, i) in days" :key="i">
      <ItineraryTimelineDay class="item heading" :date="startsAt" :day="day.dayNumber" />

      <template v-for="activity in day.activities.filter(a => a.type === 'highlight')">
        <div class="item activity activity-title" v-html="parseMarkdown(activity.title)" />

        <div class="item body" v-if="activity.description" v-html="parseMarkdown(activity.description)"></div>

        <div v-if="activity.images.length" class="item gallery">
          <MediaGallery :feature-images="highlightImages(activity.images, day)" layout="row" />
        </div>
      </template>
    </template>
  </section>
</template>

<script setup>
import ItineraryTimelineDay from '@/modules/Itinerary/Components/ItineraryTimelineDay.vue'
import MediaGallery from '@/modules/MediaGallery/MediaGallery.vue'
import { parseMarkdown } from '@/utils'

defineProps({
  days: Array,
  startsAt: String,
})

const highlightImages = (images, day) => images.map(img => ({ ...img, caption: `Day ${day.dayNumber}` }))
</script>

<style lang="scss" scoped>
$line-width: 2px;

.item {
  position: relative;
  padding-left: 24px;

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    content: '';
    border-left: $line-width solid $brand-tertiary-light;
  }

  &:first-child::before {
    /* Hide line overflowing first bullet */
    top: 50%;
    height: 50%;
  }

  /* Hide line overflowing last bullet */
  &::after {
    position: absolute;
    top: 50%;
    left: $line-width / 2; /* Center bullets/icons on line */
    z-index: 2;
    content: '';
    transform: translate(-50%, -50%);
  }

  &.heading::after,
  &.activity::after {
    border: 1px solid $brand-tertiary;
    border-radius: 50%;
  }

  &.heading::after {
    width: 8px;
    height: 8px;
    background-color: $brand-tertiary;
  }

  &.activity::after {
    width: 0.375rem;
    height: 0.375rem;
    background-color: $white;
  }
}

.heading {
  color: $brand-primary;
  padding-block: 8px;
}

.heading,
.activity {
  font-weight: 600;
}

.activity {
  padding-block: 8px;
}

:deep(.activity-title) {
  @include markdown-display;
}

.body {
  padding-block: 4px;

  &:deep {
    @include markdown-display;
  }
}

.gallery {
  padding-block: 16px;
}
</style>
